import React from 'react';
import { useSelector, useDispatch } from 'react-redux'
import isEmpty from 'lodash/isEmpty';
import { Creators as actions } from '../../redux/actions';
import {
    getFinanceOptions,
    getMetaFinancePlans,
    getSelectedFinancePlan,
    getSelectedFinanceOptions,
    getMoneyFormatter,
    getSelectedFinanceOptionsIndex,
    getHasTaxesIncluded,
    getPaymentOptions
} from '../../redux/selectors';

import { t } from 'react-i18nify';
import { paymentWithTaxDetails } from '../../libs/helpers'

const Terms = () => {
    const financeOptionsIndex = useSelector(getSelectedFinanceOptionsIndex)
    const financeOptions = useSelector(getSelectedFinanceOptions)
    const formatAsMoney = useSelector(getMoneyFormatter)

    const dispatch = useDispatch()

    if (isEmpty(financeOptions)) {
        return null
    }

    const { selectedCashDown, selectedPayment, paymentFrequency, cashDownOptions = {} } = financeOptions
    const { terms } = cashDownOptions.find(cashDownOption => cashDownOption.cashDown === selectedCashDown) || {}

    const selectPayment = (term) => dispatch(actions.selectPayment(selectedCashDown, term, financeOptionsIndex))

    const { paymentTaxes, taxesDetail, totalPayment } = selectedPayment || {};

    return (
        <div className="vehicle-payment-tabs__content-item">
            <div className="calculator-popup-table-term-selector">
                <div className="calculator-popup-table-term-selector__elem">
                    <div className="calculator-popup-table-term-selector__item">
                        <span className="calculator-popup-table-term-selector__item-label">{t('calculatorTableTerm')}</span>
                        <span className="calculator-popup-table-term-selector__item-label">{t('calculatorTableRate')}</span>
                        <span className="calculator-popup-table-term-selector__item-label">{t('calculatorTablePayment')}</span>
                    </div>
                </div>
                <div className="calculator-popup-table-term-selector__elem">
                {
                terms.map((term, i) => {
                        const hasTaxesIncluded = false;
                        const payment = hasTaxesIncluded ? term.totalPayment : term.payment;

                        const active = (
                            term.payment === selectedPayment.payment &&
                            term.totalPayment === selectedPayment.totalPayment
                        ) ? 'active' : '';

                        return (
                            <div className={`calculator-popup-table-term-selector__item-finance ${active}`} key={i}
                                onClick={() => selectPayment(term.term)}>
                                <div className="calculator-popup-table-term-selector__item-finance-term">
                                    <p className="calculator-popup-table-term-selector__item-finance-term-value">{term.term}</p>
                                    <p className="calculator-popup-table-term-selector__item-finance-term-label">{t('monthly')}</p>
                                </div>
                                <div className="calculator-popup-table-term-selector__item-finance-payment-rate">
                                    <div className="calculator-popup-table-term-selector__item-finance-payment-rate-row">
                                        <div className="calculator-popup-table-term-selector__item-finance-rate">
                                            <p className="calculator-popup-table-term-selector__item-finance-payment-value">{term.apr}</p>
                                            <p className="calculator-popup-table-term-selector__item-finance-payment-label">%</p>
                                        </div>
                                        <div className="calculator-popup-table-term-selector__item-finance-payment">
                                            <p className="calculator-popup-table-term-selector__item-finance-payment-value">{formatAsMoney(payment)}</p>
                                            <p className="calculator-popup-table-term-selector__item-finance-payment-label">{t(`paymentFrequency.${paymentFrequency}`)}</p>
                                        </div>
                                    </div>
                                    {active && <div className="calculator-popup-table-term-selector__item-finance-payment-rate-row">
                                        <div className="calculator-popup-table-term-selector__item-finance-result">
                                            <p className="smallprint" data-theme-style="smallprint">{
                                                paymentWithTaxDetails(
                                                    formatAsMoney(term.payment, 2),
                                                    formatAsMoney(paymentTaxes, 2),
                                                    taxesDetail,
                                                    formatAsMoney(totalPayment, 2)
                                                )}
                                            </p>
                                        </div>
                                    </div>}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default Terms;